<form class="form" [formGroup]="billingDetailsForm" (ngSubmit)="submit()" novalidate id="invoice-settings-form">
  <content-state [isLoading]="isDataLoading">
    <div class="flex flex-col gap-2" [ngClass]="{ 'p-4': !noPadding }">
      <sb-form-field
        [errorWhen]="['touched']"
        [control]="billingDetailsForm.controls.invoice_company"
        [label]="'Company name' | translate"
      >
        <input
          sbInput
          type="text"
          id="invoice_company"
          name="invoice_company"
          [formControl]="billingDetailsForm.get('invoice_company')"
        />
      </sb-form-field>

      <sb-form-field
        [errorWhen]="['touched']"
        [control]="billingDetailsForm.controls.invoice_email"
        [label]="'Billing email' | translate"
      >
        <input
          sbInput
          type="text"
          id="invoice_email"
          name="invoice_email"
          [formControl]="billingDetailsForm.get('invoice_email')"
        />
      </sb-form-field>

      <div class="flex gap-4">
        <sb-form-field
          class="flex-1"
          [errorWhen]="['touched']"
          [control]="billingDetailsForm.controls.first_name"
          [label]="'First name' | translate"
        >
          <input
            sbInput
            type="text"
            id="first_name"
            name="first_name"
            [formControl]="billingDetailsForm.get('first_name')"
          />
        </sb-form-field>

        <sb-form-field
          class="flex-1"
          [errorWhen]="['touched']"
          [control]="billingDetailsForm.controls.last_name"
          [label]="'Last name' | translate"
        >
          <input
            sbInput
            type="text"
            id="last_name"
            name="last_name"
            [formControl]="billingDetailsForm.get('last_name')"
          />
        </sb-form-field>
      </div>

      <sb-form-field
        [errorWhen]="['touched']"
        [control]="billingDetailsForm.controls.street_address"
        [label]="'Address' | translate"
      >
        <input
          sbInput
          type="text"
          id="street_address"
          name="street_address"
          [formControl]="billingDetailsForm.get('street_address')"
        />
      </sb-form-field>

      <sb-form-field
        [errorWhen]="['touched']"
        [control]="billingDetailsForm.controls.zipcode"
        [label]="'Zipcode' | translate"
      >
        <input sbInput type="text" id="zipcode" name="zipcode" [formControl]="billingDetailsForm.get('zipcode')" />
      </sb-form-field>

      <sb-form-field
        [errorWhen]="['touched']"
        [control]="billingDetailsForm.controls.city"
        [label]="'City' | translate"
      >
        <input sbInput type="text" id="city" name="city" [formControl]="billingDetailsForm.get('city')" />
      </sb-form-field>

      <sb-form-field
        [errorWhen]="['touched']"
        [control]="billingDetailsForm.controls.country"
        [label]="'Country' | translate"
      >
        <sb-select
          [formControl]="billingDetailsForm.get('country')"
          [items]="countries"
          [searchable]="true"
        ></sb-select>
      </sb-form-field>

      <sb-form-field
        [control]="billingDetailsForm.get('vat')"
        [label]="'VAT number' | translate"
        [overrideError]="billingDetailsForm.get('vat').errors?.invalidVat"
        [overrideErrorMessage]="'Invalid VAT number' | translate"
      >
        <span ngProjectAs="label-suffix">{{ 'Optional' | translate }}</span>
        <sb-form-group>
          <div sbFormGroupPrefix>{{ billingDetailsForm.value.country }}</div>
          <input sbInput type="text" id="vat" name="vat" [formControl]="billingDetailsForm.get('vat')" />
          @if (vatValidator.validating()) {
            <sb-spinner sbFormGroupSuffix [size]="'sm'" [strokeColor]="'current'" />
          } @else if (vatValidator.status() === vatResponseStatus.VALID) {
            <div sbFormGroupSuffix>
              <sb-icon class="text-success" size="sm" name="check" />
            </div>
          }
        </sb-form-group>
      </sb-form-field>
    </div>

    @if (!hideButtonBar) {
      <div class="flex justify-end gap-2 px-4 pt-7 pb-1">
        @if (backButtonEnabled) {
          <button sb-button [color]="'secondary'" [disabled]="isLoading" (click)="backPressed.emit()">
            {{ 'Back' | translate }}
          </button>
        }
        <button
          sb-button
          [color]="'primary'"
          type="submit"
          [sbLadda]="isLoading"
          [disabled]="billingDetailsForm.status === 'PENDING'"
        >
          {{ saveLabel ?? 'Save' | translate }}
        </button>
      </div>
    }
  </content-state>
</form>
